export const ShortTermSubmitStatus = Object.freeze({
  Accept: 0,
  Modify: 1,
  Cancel: 2,
})
